export { writeTemplateIfMissing } from '@webpieces/rules-config';
